import { select } from '@panel/commons/core/themev2';
import styled, { css } from 'styled-components';
import FullIcon from '../../../../assets/icons/full_quality.svg';
import PositiveIcon from '../../../../assets/icons/face_positive.svg';
import WarmIcon from '../../../../assets/icons/face_warm.svg';
import NegativeIcon from '../../../../assets/icons/face_negative.svg';
import NeutralIcon from '../../../../assets/icons/face_neutral.svg';

const siteId = process.env.REACT_APP_BUILD_SITE;
const isBrazilPortal = siteId && siteId.includes('BR');

const ProgressStyles = {
  ok: {
    icon: PositiveIcon,
    barColor: select('accessibleGreen')
  },
  warn: {
    icon: WarmIcon,
    barColor: select('darkestYellow')
  },
  error: {
    icon: NegativeIcon,
    barColor: select('negative')
  },
  not_apply: {
    icon: NeutralIcon,
    barColor: select('midNeutralGray')
  },
  loading: {
    icon: NeutralIcon,
    barColor: select('midNeutralGray')
  }
};

const CardContent = styled.div`
  display: flex;
  flex-direction: ${({ device }) => (device === 'mobile' ? 'column' : 'row')};
  align-items: ${({ centerRow }) => (centerRow ? 'center' : 'flex-start')};
  gap: 16px;
`;

const ContainerQuality = styled.div`
  width: ${({ device }) => (device !== 'mobile' ? 'auto' : '100%')};
  display: flex;
  align-items: ${({ centerRow }) => (centerRow ? 'center' : 'flex-start')};
  gap: 16px;
`;

const CircleChart = styled.div`
  display: flex;
  width: 57px;
  height: 57px;
  position: relative;
  flex-shrink: 0;

  .icon-container {
    background-color: white;
    right: 1px;
    bottom: 2px;
    position: absolute;
    border-radius: 50%;
    .face-icon {
      background-image: ${({ qualityStatus, isFull }) => {
        if (isFull) return `url(${FullIcon})`;
        return qualityStatus && `url(${ProgressStyles[qualityStatus]?.icon})`;
      }};
      min-width: 18.5px;
      min-height: 18.5px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
  .single-chart {
    width: 100%;
  }
  .circular-chart {
    display: block;
    max-height: 250px;
    ${({ qualityNotApply }) =>
      qualityNotApply &&
      css`
        cursor: not-allowed !important;
      `};
  }
  .circle-bg {
    fill: none;
    stroke: ${({ qualityStatus }) =>
      qualityStatus === 'not_apply' || qualityStatus === 'loading'
        ? ProgressStyles[qualityStatus]?.barColor
        : select('middleGray')};
    stroke-width: 2.5;
  }
  .circle {
    fill: none;
    stroke-width: 2.5;
    stroke-linecap: round;
  }
  .circular-chart .circle {
    stroke: ${({ qualityStatus }) => ProgressStyles[qualityStatus]?.barColor || select('middleGray')};
    display: flex;
  }
  .percentage {
    fill: ${({ qualityStatus }) => (qualityStatus ? ProgressStyles[qualityStatus]?.barColor : select('darkGray'))};
    font-family: 'Hind';
    font-style: normal;
    font-weight: 400;
    font-size: 8px;
    text-anchor: middle;
    display: flex;
  }
  .label {
    fill: ${select('midDarkGrayAux')};
    font-size: ${({ qualityNotApply }) => (isBrazilPortal && qualityNotApply ? '0.36em' : '0.45em')};
    font-weight: 400;
    text-anchor: middle;
  }
`;

const Title = styled.div`
  font-family: Hind;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  white-space: normal;
`;

const TextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  .textWrapper {
    > div:last-child {
      margin-bottom: 0;
    }
  }
  .text {
    display: flex;
    gap: 8px;
    margin: 0 0 8px 8px;
    font-family: Hind;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    white-space: normal;
  }
`;

export { CardContent, ContainerQuality, CircleChart, Title, TextContainer, ProgressStyles };
